const CHANGE_USER_EMAIL_FORM = {
    submit: {
        label: 'change_user_email.change_btn'
    },
    fields: [
        {
            name: 'email',
            label: 'change_user_email.email_field',
            type: 'text',
            validators: ['required', 'isEmail'],
            errors: ['errors.required_email', 'errors.invalid_email'],
            defaultValue: ''
        }
    ]
}

export default CHANGE_USER_EMAIL_FORM;
